import { CommApiInstance} from "Utils/CommApiInstance";




const MembGameLoginApi = async (
    gameSvcCd:string|null    ,
    loginId:string           ,
    passwd:string            ,
    cptchTkn:string          ,
    redirectUri:string|null  ,
    mltSetYn:string          ,
) => {
    return await CommApiInstance.post(`game/${gameSvcCd}/login_web`,{
        apiBody: {
            loginId:loginId,
            passwd:passwd,
            cptchTkn:cptchTkn,
            redirectUri:redirectUri,
            mltSetYn:mltSetYn
        }
    });
}
export default MembGameLoginApi;